
export default function DayAtKirari() {
  const schedule = [
    {
      time: '7:30 - 9:00',
      title: '登園・自由遊び',
      description: '温かくお迎えし、子どもたちが落ち着くまで自由遊びの時間',
      icon: 'ri-sun-line',
    },
    {
      time: '9:00 - 9:30',
      title: '朝の会',
      description: '歌、お話、みんなで共有する集まりの時間',
      icon: 'ri-group-line',
    },
    {
      time: '9:30 - 10:30',
      title: '学習活動',
      description: '構造化された教育活動と創造的な探求',
      icon: 'ri-palette-line',
    },
    {
      time: '10:30 - 11:00',
      title: 'おやつの時間',
      description: '健康的なおやつと社会的な交流',
      icon: 'ri-cake-line',
    },
    {
      time: '11:00 - 12:00',
      title: '外遊び',
      description: '身体活動と自然探索',
      icon: 'ri-plant-line',
    },
    {
      time: '12:00 - 13:00',
      title: '昼食',
      description: '栄養バランスの取れた食事と自立心の育成',
      icon: 'ri-restaurant-2-line',
    },
    {
      time: '13:00 - 15:00',
      title: 'お昼寝',
      description: 'お昼寝または静かな活動の時間',
      icon: 'ri-moon-line',
    },
    {
      time: '15:00 - 16:00',
      title: '午後の活動',
      description: '芸術、音楽、体験学習',
      icon: 'ri-music-line',
    },
    {
      time: '16:00 - 18:00',
      title: '自由遊び・降園',
      description: 'ご家族のお迎えまで自由に遊ぶ時間',
      icon: 'ri-home-heart-line',
    },
  ];

  return (
    <section id="day-at-kirari" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            きらりの一日
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            学び、遊び、休息、栄養のバランスを考えた一日のスケジュールで、お子さまの発達と健康をサポートします。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            {schedule.map((item, index) => (
              <div
                key={index}
                className="flex gap-6 bg-gray-50 rounded-xl p-6 hover:bg-teal-50 transition-colors duration-300"
              >
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-baseline gap-3 mb-2">
                    <span className="text-sm font-bold text-teal-600 whitespace-nowrap">
                      {item.time}
                    </span>
                    <h4 className="text-lg font-bold text-gray-900">
                      {item.title}
                    </h4>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:sticky lg:top-24">
            <div className="rounded-2xl overflow-hidden shadow-2xl mb-8">
              <img
                src="https://static.readdy.ai/image/8d13d909127b965a1b96285c4b9af1e2/e66b9e5c027b34a5c245a4de5e98db51.jpeg"
                alt="きらりの一日"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="bg-teal-600 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">柔軟なスケジュール</h3>
              <p className="text-sm leading-relaxed opacity-95">
                ご家庭によってニーズは様々です。子どもたちの一貫性を保ちながら、柔軟に対応できるスケジュールを設計しています。全日制・半日制のプログラムがあり、働くご家族のための延長保育もご利用いただけます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
